import React from 'react'
import PropTypes from 'prop-types'
import { useMakeDispatchCallback } from 'hooks'

import strings from 'utils/strings'

import { HISTORY, CURRENT } from 'constants/featureSnapshots'

import { setSelectedIdWithDrawer } from 'actions/navigator'

import { StyledButton } from './FeatureEditor.style'

const FeatureOverflowMenu = ({ replaceRoute }) => {
  const setSelectedIdCallback = useMakeDispatchCallback(setSelectedIdWithDrawer)

  const handleSelect = () => {
    replaceRoute({ search: `?${HISTORY}=${CURRENT}` })
    setSelectedIdCallback(HISTORY)
  }

  return (
    <StyledButton
      type="text"
      iconProps={{ icon: 'history' }}
      onClick={handleSelect}
    >
      {strings.version_history}
    </StyledButton>
  )
}

FeatureOverflowMenu.propTypes = {
  replaceRoute: PropTypes.func,
}

export default FeatureOverflowMenu
